import { Component, OnInit } from '@angular/core';
import 'rxjs';
declare var $:any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  title = "Building Advanced Business Systems for Today’s Real Estate Professionals ";

  public products = [
    {
      title:'Title Tool Box',
      summary: "Title Tool Box is providing the ability to pull farms immediately and is empowering the individual\n" +
        "to take control of their data needs.  Looking for a specificc geographical farm, property information\n" +
        "surrounding a specific property or client based on a radius or boundary search...",
      image: '/assets/images/devices-ttb.png',
      icon: 'title-toolox',
      link: '/title-toolbox'
    },
    {
      title:'Premier List Fulfillment Solutions',
      summary: "With Benutech’s Premier List Fulfillment Solutions, the real estate professional\n" +
        "(mortgage, title, investor, broker, agent etc.) can now benefit from flexible data solutions\n" +
        "to fit exactly-targeted marketing audiences to achieve a better...",
      image: '/assets/images/devices-premier.png',
      icon: 'premier_list',
      link: '/premiere-list'
    },
    {
      title:'Rebo Gateway',
      summary: "Choose from a catalog of opportunities such as Divorce, Tax Defaults, Expired Listings,\n" +
        "For Sale by Owner, Notice of Default and Sale, Just Listed and Sold, and several additional\n" +
        "categories.  Updated daily, ReboGateway provides unlimited access to information...",
      image: '/assets/images/devices-rg.png',
      icon: 'rebogaatway',
      link: '/rebo-gateway'
    },
    {
      title:'Investor’s Title Tool Box',
      summary: "In the real estate investment market, competition is fierce, deals become scarce and overbidding is rampant.\n" +
        "Benutech, Inc. has developed a new tool to find the off market property deals. Welcome to the\n" +
        "INVESTOR’S TITLE TOOLBOX... INVESTOR‘S TITLE TOOLBOX is a revolutionary process..." +
        "you to search Nationwide!",
      image: '/assets/images/devices-ittb.png',
      icon: 'ittb',
      link: '/investors-title-toolbox'
    }
  ];

  ngAfterViewInit(){
    $('.product').slick({
      autoplay: false,
      dots: true,
      arrows: true
    });
  }

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/src/app/pages/home/home.component.ts